export default __webpack_public_path__ + "897d1346a34d4789003db5d7ca962adc.png";